export const NOTIFICATIONS_STATUSES = {
  READ: '2_READ',
  STATUS_READ: 'READ',
};

export const UnreadNotificationStatusPrefix = '1_';
